







import Vue from 'vue'
import CurrentFileTab from '../../transport-directory/components/CurrentFileTab.vue'

export default Vue.extend({
  name: 'DirectoryContent',
  props: {
    visible: { // 是否展示
      type: Boolean,
      default: false
    },
    selectDirectory: {
      type: Object,
      default: () => ({})
    }
  },
  components: { CurrentFileTab },
  data() {
    return {}
  },
  methods: {
    // 关闭弹出
    handleCancel() {
      this.$emit('close')
    }
  }
})
